import { createSlice } from '@reduxjs/toolkit'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { GetChannelListRequest, getChannelList } from '../api/channel'
import { Channel } from '../components/partners'

export type ChannelListState = {
   isPristine: boolean
   isFetching: boolean
   items: Array<Channel>
   totalSize: number
}

const initialState: ChannelListState = {
   isPristine: true,
   isFetching: false,
   items: [],
   totalSize: 0,
}

export const getChannelListThunk = createAsyncThunk(
   'getChannelList',
   async (request: GetChannelListRequest | undefined, { rejectWithValue }) => {
      try {
         return await getChannelList(request)
      } catch {
         return rejectWithValue(null)
      }
   },
)

export const channelListSlice = createSlice({
   name: 'channelListSlice',
   initialState,
   reducers: {
      clear: () => {
         return initialState
      },
   },
   extraReducers(builder) {
      builder.addCase(getChannelListThunk.pending, (state) => {
         state.isPristine = false
         state.isFetching = true
      })
      builder.addCase(getChannelListThunk.fulfilled, (state, action) => {
         const { payload } = action
         state.isPristine = false
         state.isFetching = false
         state.items = payload.items
         state.totalSize = payload.totalSize
      })
      builder.addCase(getChannelListThunk.rejected, (state) => {
         state.isPristine = false
         state.isFetching = false
      })
   },
})

export const { clear } = channelListSlice.actions

export default channelListSlice.reducer
